// import React, { useState } from "react";
// import {
//   Alert,
//   Button,
//   InfoCard,
//   InfoText,
//   PageTitle,
//   Separator,
//   Tag,
//   ToolTip,
//   InfoTimeCardAdv,
//   Divider,
//   DetailCard,
//   Chip,
//   AdvSeparator,
//   InfoTextAdv,
// } from "../../../../components";

// const InfoItems = () => {
//   const [isShowAlert, setIsShowAlert] = useState(false);
//   const variants = [
//     "text",
//     "contained",
//     "outlined",
//     "titleContained",
//     "valueContained",
//   ];
//   const variantsTwo = ["text", "contained", "outlined"];
//   const colors = ["primary", "warning", "success", "danger", "info", "black"];
//   const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
//   const oneLines = [true, false];

//   const aligns = ["left", "center", "right"];
//   return (
//     <div className="flex gap-5 flex-col overflow-auto">
//       <div className="grid grid-cols-2 gap-5 m-4">
//         <div>
//           <DetailCard
//             title={
//               <div>
//                 <h6 className="line-clamp-1">MOHR Test and Measurement LLC</h6>
//               </div>
//             }
//             headeRight={
//               <div className="mr-2">
//                 <Button icon={"add"} type="icon" size="sm" />
//               </div>
//             }
//           >
//             <AdvSeparator gap="gap-5">
//               <InfoTextAdv
//                 title={"Created On"}
//                 titleProps={{ className: "!text-black" }}
//                 value={
//                   <h5 className="line-clamp-1 text-black">July 8, 2024</h5>
//                 }
//               />
//               <InfoTextAdv
//                 title={"Last Used"}
//                 titleProps={{ className: "!text-black" }}
//                 value={
//                   <h5 className="line-clamp-1 text-black">October 9, 2024</h5>
//                 }
//               />
//               <InfoTextAdv
//                 title={"Modified On"}
//                 titleProps={{ className: "!text-black" }}
//                 value={
//                   <h5 className="line-clamp-1 text-black">July 8, 2024</h5>
//                 }
//               />
//             </AdvSeparator>
//           </DetailCard>
//         </div>
//         <div>
//           <DetailCard
//             title={
//               <div>
//                 <h6 className="line-clamp-1">MOHR Test and Measurement LLC</h6>
//               </div>
//             }
//             headeRight={
//               <div className="mr-2">
//                 <Button icon={"add"} type="icon" size="sm" />
//               </div>
//             }
//           >
//             <div className="flex justify-between items-center">
//               <div>https://testinc.com</div>
//               <div>
//                 <Chip
//                   label="Civil Engineering"
//                   color="invoiced"
//                   className="!rounded-full"
//                 />
//               </div>
//             </div>
//           </DetailCard>
//         </div>
//         {/* <DetailCard title="This is a string title">
//           a dfabsdfo yabsdop fabsdfy asdfyasdf oy{" "}
//         </DetailCard> */}
//         <div>
//           <DetailCard
//             size="xs"
//             title={
//               <div className="flex items-center gap-2">
//                 <span class="material-symbols-outlined !text-lg">
//                   alarm_add
//                 </span>
//                 <div className="font-bold text-xs">
//                   Tue, 28/Mar/2025 21:40:20 PM
//                 </div>
//               </div>
//             }
//             headeRight={
//               <div>
//                 <Button
//                   icon={"edit_square"}
//                   variant="text"
//                   type="icon"
//                   size="sm"
//                   color="black"
//                 />
//               </div>
//             }
//           >
//             <div className="my-2 mx-1 text-sm">
//               (Inspector or Inspection or Inspecting) and (Construction or
//               Civil) and (Transportation or Bridge or “Complex Category 2” or
//               “CC2”)
//             </div>
//           </DetailCard>
//         </div>
//       </div>
//       <div className="grid grid-cols-6 gap-5">
//         <InfoCard value={"50"} prefix={"Rs"} suffix={"Lakh"} />
//         <InfoCard color="type2" value={500} suffix={"M"} />
//         <InfoCard
//           color="type3"
//           value={124}
//           action={() => setIsShowAlert(true)}
//         />
//       </div>
//       <div className="flex gap-5 items-center">
//         <InfoText title={"Reporting Manager"} value={""} />
//         <InfoText
//           title={"Project Manager"}
//           value={"asdfasdf asdf asd asdf asd"}
//         />
//       </div>
//       <div className="flex gap-5 items-center">
//         <InfoText icon={"chip_extraction"} value={""} />
//         <InfoText icon={"open_run"} value={"1000"} />
//       </div>
//       {/* InfoTimeCardAdv Variants with Colors */}
//       <div className="mt-5">
//         <h3 className="text-lg font-semibold mb-3">
//           InfoTimeCardAdv Variants with Colors
//         </h3>
//         {variants.map((variant, variantIndex) => (
//           <div key={`variant-${variantIndex}`} className="mb-8">
//             <h4 className="text-md font-medium mb-2">Variant: {variant}</h4>
//             <div className="grid grid-cols-6 gap-4">
//               {colors.map((color, colorIndex) => (
//                 <div key={`${variant}-${color}-${colorIndex}`}>
//                   <InfoTimeCardAdv
//                     title="Amount Used"
//                     value="12768.00"
//                     prefix="$"
//                     suffix="USD"
//                     variant={variant}
//                     color={color}
//                   />
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* InfoTimeCardAdv Sizes */}
//       <div className="mt-5">
//         <h3 className="text-lg font-semibold mb-3">InfoTimeCardAdv Sizes</h3>
//         <div className="grid grid-cols-6 gap-4">
//           {sizes.map((size, index) => (
//             <div>
//               <InfoTimeCardAdv
//                 title="Amount Used"
//                 value="12768.00"
//                 prefix="$"
//                 suffix="USD"
//                 size={size}
//               />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* InfoTimeCardAdv Aligns */}
//       <div className="mt-5">
//         <h3 className="text-lg font-semibold mb-3">InfoTimeCardAdv Aligns</h3>
//         <div className="grid grid-cols-3 gap-4">
//           {aligns.map((align, index) => (
//             <InfoTimeCardAdv
//               title="Amount Used"
//               value="12768.00"
//               prefix="$"
//               suffix="USD"
//               align={align}
//             />
//           ))}
//         </div>
//       </div>
//       <div className="mt-5">
//         <h3 className="text-lg font-semibold mb-3">InfoTimeCardAdv Aligns</h3>
//         <div className="grid grid-cols-6 gap-4">
//           {oneLines.map((oneLine, index) => (
//             <>
//               <InfoTimeCardAdv
//                 title="Amount Used"
//                 value="12768.00"
//                 prefix="$"
//                 suffix="USD"
//                 oneLine={oneLine}
//               />
//             </>
//           ))}
//         </div>
//       </div>

//       <div className="flex gap-2">
//         <div className="w-[800px]">
//           <InfoTimeCardAdv
//             title="Amount Used"
//             value="12768.00"
//             prefix="$"
//             suffix="USD"
//           />
//         </div>
//         <Divider orientation="vertical" />
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Amount Used"
//             value="12768.00"
//             prefix="$"
//             suffix="USD"
//           />
//         </div>
//         <Divider orientation="vertical" />
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Amount Used"
//             value="12768.00"
//             prefix="$"
//             suffix="USD"
//           />
//         </div>
//         <Divider orientation="vertical" />
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Amount Used"
//             value="12768.00"
//             prefix="$"
//             suffix="USD"
//           />
//         </div>
//         <Divider orientation="vertical" />
//         <div className="flex-1">
//           <InfoTimeCardAdv
//             title="Amount Used"
//             value="12768.00"
//             prefix="$"
//             suffix="USD"
//           />
//         </div>
//       </div>

//       <div>
//         <div className="mt-5">
//           <h3 className="text-lg font-semibold mb-3">
//             InfoTimeCardAdv Variants with Colors
//           </h3>
//           {variantsTwo.map((variant, variantIndex) => (
//             <div key={`variant-${variantIndex}`} className="mb-8">
//               <h4 className="text-md font-medium mb-2">Variant: {variant}</h4>
//               <div className="flex flex-wrap justify-between gap-4">
//                 {colors.map((color, colorIndex) => (
//                   <div key={`${variant}-${color}-${colorIndex}`}>
//                     <InfoTimeCardAdv
//                       type="type2"
//                       value="12768.00"
//                       prefix="$"
//                       suffix="USD"
//                       variant={variant}
//                       //variant={"text"}
//                       color={color}
//                     />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <Alert
//         isOpen={isShowAlert}
//         onClose={() => setIsShowAlert(false)}
//         title="Delete Item"
//         description="Are you sure you want to delete this item? This action cannot be undone."
//         cancelButton={{
//           show: true,
//           title: "Cancel",
//           onClick: () => console.log("Cancelled"),
//         }}
//         acceptButton={{
//           show: true,
//           title: "Delete",
//           onClick: () => console.log("Delete"),
//         }}
//       />
//     </div>
//   );
// };

// export default InfoItems;

import React from "react";
import { NewTab, PageTab } from "../../../../components";
import InfoCardList from "./InfoList/InfoCardList";
import InfoTextList from "./InfoList/InfoTextList";
import InfoTimeCardAdvList from "./InfoList/InfoTimeCardAdvList";
import DetailCardList from "./InfoList/DetailCardList";
import InfoCircleList from "./InfoList/InfoCircleList";
import InfoCardWithCircleList from "./InfoList/InfoCardWithCircleList";
import NodataList from "./InfoList/NodataList";
import HoverInfo from "./InfoList/HoverInfo";
import DocumentCardList from "./InfoList/DocumentCardList";
import SignatureCardList from "./InfoList/SignatureCardList";
import KpiList from "./InfoList/KpiList";

const InfoItems = () => {
  const tabList = [
    {
      title: "KPI",
      page: <KpiList />,
      type: "main",
    },
    {
      title: "Nodata",
      page: <NodataList />,
      type: "main",
    },
    {
      title: "Info Card",
      page: <InfoCardList />,
      type: "main",
    },
    {
      title: "Info Text",
      page: <InfoTextList />,
      type: "main",
    },
    {
      title: "Info Time Card Adv",
      page: <InfoTimeCardAdvList />,
      type: "main",
    },
    {
      title: "Detail Card",
      page: <DetailCardList />,
      type: "main",
    },
    {
      title: "Info Circle",
      page: <InfoCircleList />,
      type: "main",
    },
    {
      title: "Info Card With Circle",
      page: <InfoCardWithCircleList />,
      type: "main",
    },
    {
      title: "Document Card",
      page: <DocumentCardList />,
      type: "main",
    },
    {
      title: "Hover Info",
      page: <HoverInfo />,
      type: "main",
    },
    {
      title: "Signature Card",
      page: <SignatureCardList />,
      type: "main",
    },
  ];
  return (
    <div className="w-full p-2 flex flex-1 overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="info-items"
      />
    </div>
  );
};

export default InfoItems;
